import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function updateLeads(
  uname,
  token,
  id,
  cognome,
  nome,
  mail,
  tag,
  telefono,
  prenotazione,
  dataIscrizione,
  eta,
  citta,
  idCorso
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateLeads.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        resolve();
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id: id,
      cognome: Utils.escapeString(cognome),
      nome: Utils.escapeString(nome),
      mail: mail,
      tag: tag,
      telefono: telefono,
      prenotazione: prenotazione,
      data_iscrizione: dataIscrizione || "",
      eta: eta || "",
      citta: Utils.escapeString(citta) || "",
      id_corso: idCorso || "",
    });

    req.write(postData);

    req.end();
  });
}
